export const LOGO_OPTIONS = [
    { label: 'Logo (média)', url: 'https://jfartqkalyqjwyueqfet.supabase.co/storage/v1/object/public/logo/media-9.png' },
    { label: 'Logo noir', url: 'https://jfartqkalyqjwyueqfet.supabase.co/storage/v1/object/public/logo/black-logo.svg' },
    { label: 'Smiley + wordmark', url: 'https://jfartqkalyqjwyueqfet.supabase.co/storage/v1/object/public/logo/smiley-with-word-logo.svg' },
];

export const SENDER_NAME_OPTIONS = (authorName) => [
    ...(authorName ? [
        `${authorName} for winston.ie`,
        `${authorName} · winston.ie`,
        `${authorName} with winston.ie`,
    ] : []),
    'winston.ie',
    'winston.ie by Longden Collective',
    'winston.ie | Longden Collective',
    'Longden Collective',
    'Updates from winston.ie',
    'winston.ie - News',
    'The winston.ie Team',
];

export const CITY_PRESETS = [
    'Montréal, Canada',
    'Toronto, Canada',
    'Vancouver, Canada',
    'Ho Chi Minh City, Vietnam',
    'Thành Phố Hồ Chí Minh, Việt Nam',
];

export const TIMEZONE_OPTIONS = [
    { label: 'Montréal / Toronto (heure de l\'Est)', tz: 'America/Toronto' },
    { label: 'Vancouver (heure du Pacifique)', tz: 'America/Vancouver' },
    { label: 'Hô Chi Minh-Ville (Indochine)', tz: 'Asia/Ho_Chi_Minh' },
];

const C = { bg: '#ffffff', text: '#17171a', muted: '#8f8b7f', border: '#ececec' };

function stripBlankLines(html) {
    return html.split('\n').filter(line => line.trim() !== '').join('\n');
}

function formatDatelineMulti(datelineCities, timezone) {
    const now = new Date();
    const opts = timezone ? { timeZone: timezone } : {};
    const citiesStr = (datelineCities || []).join(' · ');

    const locales = { fr: 'fr-CA', en: 'en-US', vi: 'vi-VN' };
    const result = {};
    for (const [lang, locale] of Object.entries(locales)) {
        const dateStr = now.toLocaleDateString(locale, { year: 'numeric', month: 'long', day: 'numeric', ...opts });
        const timeStr = now.toLocaleTimeString(locale, { hour: '2-digit', minute: '2-digit', ...opts });
        result[lang] = `${citiesStr}${citiesStr ? ' — ' : ''}${dateStr}, ${timeStr}`;
    }
    return result;
}
function unsubscribeBlock(recipientEmail) {
    const url = recipientEmail
        ? `https://winston.longden.site/unsubscribe?email=${encodeURIComponent(recipientEmail)}`
        : `https://winston.longden.site/unsubscribe`;
    return `<tr><td align="center" style="padding: 20px 20px 0;"><p style="font-family: -apple-system, 'Helvetica Neue', Arial, sans-serif; font-size: 10px; color: ${C.muted}; margin: 0;"><a href="${url}" style="color: ${C.muted}; text-decoration: underline;">Se désabonner · Unsubscribe · Hủy đăng ký</a></p></td></tr>`;
}

export function buildEmailHtml({
    logoUrl,
    titleFr, titleEn, titleVi,
    messageFr, messageEn, messageVi,
    ctaLabel, ctaUrl,
    showOgFooter, ogImageUrl,
    showDateline, datelineCities, timezone, datelineAlign,
    recipientEmail,
}) {
    const dateMulti = formatDatelineMulti(datelineCities, timezone);
    const align = datelineAlign === 'left' ? 'left' : 'center';

    const html = `<!DOCTYPE html><html><head><meta charset="utf-8"><meta name="viewport" content="width=device-width, initial-scale=1.0"><meta name="format-detection" content="telephone=no, address=no, email=no, date=no, url=no"></head>
<body style="margin:0; padding:0; background:${C.bg}; font-family: -apple-system, 'Helvetica Neue', Arial, sans-serif;">
<table width="100%" cellpadding="0" cellspacing="0" style="background:${C.bg};"><tr><td align="center" style="padding: 48px 24px;">
<table width="520" cellpadding="0" cellspacing="0">
<tr><td align="center" style="padding: 0 20px 40px;"><img src="${logoUrl}" alt="winston.ie" style="height: 64px; width: auto;" /></td></tr>

${titleFr || messageFr ? `
${titleFr ? `<tr><td align="center" style="padding: 0 20px 10px;"><p style="font-family: -apple-system, 'Helvetica Neue', Arial, sans-serif; font-weight: 600; font-size: 21px; color: ${C.text}; margin: 0; line-height: 1.35;">${titleFr}</p></td></tr>` : ''}
${messageFr ? `<tr><td style="padding: 0 20px 20px;"><p style="font-family: -apple-system, 'Helvetica Neue', Arial, sans-serif; font-size: 15px; line-height: 1.7; color: ${C.text}; margin: 0;">${messageFr}</p></td></tr>` : ''}
<tr><td style="padding: 0 20px 20px;"><div style="width:32px; height:1px; background:${C.border};"></div></td></tr>` : ''}

${titleEn || messageEn ? `
${titleEn ? `<tr><td align="center" style="padding: 0 20px 10px;"><p style="font-family: -apple-system, 'Helvetica Neue', Arial, sans-serif; font-weight: 600; font-size: 21px; color: ${C.text}; margin: 0; line-height: 1.35;">${titleEn}</p></td></tr>` : ''}
${messageEn ? `<tr><td style="padding: 0 20px 20px;"><p style="font-family: -apple-system, 'Helvetica Neue', Arial, sans-serif; font-size: 15px; line-height: 1.7; color: ${C.text}; margin: 0;">${messageEn}</p></td></tr>` : ''}
<tr><td style="padding: 0 20px 20px;"><div style="width:32px; height:1px; background:${C.border};"></div></td></tr>` : ''}

${titleVi || messageVi ? `
${titleVi ? `<tr><td align="center" style="padding: 0 20px 10px;"><p style="font-family: -apple-system, 'Helvetica Neue', Arial, sans-serif; font-weight: 600; font-size: 21px; color: ${C.text}; margin: 0; line-height: 1.35;">${titleVi}</p></td></tr>` : ''}
${messageVi ? `<tr><td style="padding: 0 20px 20px;"><p style="font-family: -apple-system, 'Helvetica Neue', Arial, sans-serif; font-size: 15px; line-height: 1.7; color: ${C.text}; margin: 0;">${messageVi}</p></td></tr>` : ''}` : ''}

${ctaUrl ? `<tr><td align="center" style="padding: 4px 20px 36px;"><a href="${ctaUrl}" style="display:inline-block; padding: 13px 36px; background:${C.text}; color:${C.bg}; text-decoration:none; border-radius: 999px; font-family: -apple-system, 'Helvetica Neue', Arial, sans-serif; font-size: 12.5px; font-weight: 600;">${ctaLabel || 'Explorer'}</a></td></tr>` : ''}

<tr><td style="padding: 0 20px;"><div style="width:100%; height:1px; background:${C.border};"></div></td></tr>
${(showOgFooter && ogImageUrl) ? `<tr><td style="padding: 28px 0 0;"><img src="${ogImageUrl}" alt="" style="width:100%; display:block;" /></td></tr>` : ''}
${showDateline ? `
<tr><td align="${align}" style="padding: 24px 20px 2px;"><p style="font-size: 10px; color: ${C.muted}; margin: 0;">${dateMulti.fr}</p></td></tr>
<tr><td align="${align}" style="padding: 0 20px 2px;"><p style="font-size: 9.5px; color: ${C.muted}; margin: 0;">${dateMulti.en}</p></td></tr>
<tr><td align="${align}" style="padding: 0 20px 0;"><p style="font-size: 9px; color: ${C.muted}; margin: 0;">${dateMulti.vi}</p></td></tr>` : ''}<tr><td align="center" style="padding: 16px 20px 0;"><p style="font-family: -apple-system, 'Helvetica Neue', Arial, sans-serif; font-size: 10px; color: ${C.muted}; margin: 0;">© winston&#8203;.ie ${new Date().getFullYear()} · a Longden Collective label</p></td></tr>
${unsubscribeBlock(recipientEmail)}
</table></td></tr></table></body></html>`;

    return stripBlankLines(html);
}

function marketingCopy(type, authorName) {
    const isAlbum = type === 'album';
    return {
        eyebrowFr: isAlbum ? 'Nouvel album' : 'Nouveau post — blog&#8203;.ie',
        eyebrowEn: isAlbum ? 'New album' : 'New post — blog&#8203;.ie',
        eyebrowVi: isAlbum ? 'Album mới' : 'Bài viết mới — blog&#8203;.ie',
        titleFr: isAlbum && authorName ? `Découvrez le nouvel album de ${authorName}` : (isAlbum ? 'Un nouvel album vient d\'être publié' : 'Un nouveau post vient d\'être publié'),
        titleEn: isAlbum && authorName ? `Discover ${authorName}'s new album` : (isAlbum ? 'A new album has just been published' : 'A new post has just been published'),
        titleVi: isAlbum && authorName ? `Khám phá album mới của ${authorName}` : (isAlbum ? 'Một album mới vừa được đăng' : 'Một bài viết mới vừa được đăng'),
        ctaFr: isAlbum ? 'Découvrir l\'album' : 'Lire l\'article',
        ctaEn: isAlbum ? 'Discover the album' : 'Read the article',
        ctaVi: isAlbum ? 'Khám phá album' : 'Đọc bài viết',
        footerFr: '© winston&#8203;.ie · un label de Longden Collective',
        footerEn: '© winston&#8203;.ie · a Longden Collective label',
        footerVi: '© winston&#8203;.ie · một nhãn hiệu của Longden Collective',
    };
}

export function buildNotificationHtml({
    logoUrl, type, authorName, itemTitle, subtitle, customMessage,
    heroImageUrl, ctaUrl,
    showDateline, datelineCities, timezone, datelineAlign,
    recipientEmail,
}) {
    const dateMulti = formatDatelineMulti(datelineCities, timezone);
    const align = datelineAlign === 'left' ? 'left' : 'center';
    const copy = marketingCopy(type, authorName);

    const html = `<!DOCTYPE html><html><head><meta charset="utf-8"><meta name="viewport" content="width=device-width, initial-scale=1.0"><meta name="format-detection" content="telephone=no, address=no, email=no, date=no, url=no"></head>
<body style="margin:0; padding:0; background:${C.bg}; font-family: -apple-system, 'Helvetica Neue', Arial, sans-serif;">
<table width="100%" cellpadding="0" cellspacing="0" style="background:${C.bg};"><tr><td align="center" style="padding: 48px 24px;">
<table width="520" cellpadding="0" cellspacing="0">
<tr><td align="center" style="padding: 0 20px 36px;"><img src="${logoUrl}" alt="winston.ie" style="height: 64px; width: auto;" /></td></tr>

${heroImageUrl ? `<tr><td align="center" style="padding: 0 20px 32px;"><table cellpadding="0" cellspacing="0"><tr><td style="width:320px; height:320px; overflow: hidden;"><img src="${heroImageUrl}" alt="" width="320" height="320" style="width:320px; height:320px; object-fit: cover; display:block;" /></td></tr></table></td></tr>` : ''}

<tr><td align="center" style="padding: 0 20px 6px;"><p style="font-family: -apple-system, 'Helvetica Neue', Arial, sans-serif; font-size: 10px; letter-spacing: 0.1em; text-transform: uppercase; color: ${C.muted}; margin: 0;">${copy.eyebrowFr}</p></td></tr>
<tr><td align="center" style="padding: 0 20px 4px;"><p style="font-family: -apple-system, 'Helvetica Neue', Arial, sans-serif; font-weight: 600; font-size: 21px; color: ${C.text}; margin: 0; line-height: 1.35;">${copy.titleFr}</p></td></tr>
<tr><td align="center" style="padding: 0 20px 6px;"><p style="font-family: -apple-system, 'Helvetica Neue', Arial, sans-serif; font-weight: 500; font-size: 15px; color: ${C.text}; margin: 0;">« ${itemTitle} »</p></td></tr>
<tr><td style="padding: 0 20px 20px;"><div style="width:32px; height:1px; background:${C.border}; margin: 0 auto;"></div></td></tr>

<tr><td align="center" style="padding: 0 20px 6px;"><p style="font-family: -apple-system, 'Helvetica Neue', Arial, sans-serif; font-size: 10px; letter-spacing: 0.1em; text-transform: uppercase; color: ${C.muted}; margin: 0;">${copy.eyebrowEn}</p></td></tr>
<tr><td align="center" style="padding: 0 20px 6px;"><p style="font-family: -apple-system, 'Helvetica Neue', Arial, sans-serif; font-size: 13.5px; color: ${C.muted}; margin: 0;">${copy.titleEn}</p></td></tr>
<tr><td style="padding: 0 20px 20px;"><div style="width:32px; height:1px; background:${C.border}; margin: 0 auto;"></div></td></tr>

<tr><td align="center" style="padding: 0 20px 6px;"><p style="font-family: -apple-system, 'Helvetica Neue', Arial, sans-serif; font-size: 10px; letter-spacing: 0.1em; text-transform: uppercase; color: ${C.muted}; margin: 0;">${copy.eyebrowVi}</p></td></tr>
<tr><td align="center" style="padding: 0 20px 24px;"><p style="font-family: -apple-system, 'Helvetica Neue', Arial, sans-serif; font-size: 12.5px; color: ${C.muted}; margin: 0;">${copy.titleVi}</p></td></tr>

${subtitle ? `<tr><td align="center" style="padding: 0 20px 18px;"><p style="font-family: -apple-system, 'Helvetica Neue', Arial, sans-serif; font-size: 12.5px; line-height: 1.6; color: ${C.muted}; margin: 0;">${subtitle}</p></td></tr>` : ''}
${customMessage ? `<tr><td align="center" style="padding: 0 20px 22px;"><p style="font-family: -apple-system, 'Helvetica Neue', Arial, sans-serif; font-size: 13.5px; line-height: 1.7; color: ${C.text}; margin: 0;">${customMessage}</p></td></tr>` : ''}

<tr><td align="center" style="padding: 4px 20px 36px;"><a href="${ctaUrl}" style="display:inline-block; padding: 14px 40px; background:${C.text}; color:${C.bg}; text-decoration:none; border-radius: 999px; font-family: -apple-system, 'Helvetica Neue', Arial, sans-serif; font-size: 12.5px; font-weight: 600;">${copy.ctaFr} · ${copy.ctaEn} · ${copy.ctaVi}</a></td></tr>

<tr><td style="padding: 0 20px;"><div style="width:100%; height:1px; background:${C.border};"></div></td></tr>
${showDateline ? `
<tr><td align="${align}" style="padding: 24px 20px 2px;"><p style="font-size: 10px; color: ${C.muted}; margin: 0;">${dateMulti.fr}</p></td></tr>
<tr><td align="${align}" style="padding: 0 20px 2px;"><p style="font-size: 9.5px; color: ${C.muted}; margin: 0;">${dateMulti.en}</p></td></tr>
<tr><td align="${align}" style="padding: 0 20px 0;"><p style="font-size: 9px; color: ${C.muted}; margin: 0;">${dateMulti.vi}</p></td></tr>` : ''}<tr><td align="center" style="padding: 16px 20px 4px;"><p style="font-family: -apple-system, 'Helvetica Neue', Arial, sans-serif; font-size: 9.5px; color: ${C.muted}; margin: 0;">${copy.footerFr}</p></td></tr>
<tr><td align="center" style="padding: 0 20px 4px;"><p style="font-family: -apple-system, 'Helvetica Neue', Arial, sans-serif; font-size: 9.5px; color: ${C.muted}; margin: 0;">${copy.footerEn}</p></td></tr>
<tr><td align="center" style="padding: 0 20px 0;"><p style="font-family: -apple-system, 'Helvetica Neue', Arial, sans-serif; font-size: 9.5px; color: ${C.muted}; margin: 0;">${copy.footerVi}</p></td></tr>
${unsubscribeBlock(recipientEmail)}
</table></td></tr></table></body></html>`;

    return stripBlankLines(html);
}